import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceSchema } from '../base/index.js';
export const SendInvoicePathRequestSchema = z.object({});
export const SendInvoiceApiSchema = {
    params: z.object({
        entityId: CornSchema,
        invoiceId: z.string(),
    }),
    headers: z.object({ requestActor: z.string() }),
    response: InvoiceSchema.optional(),
};
export const SendInvoicePathSchema = SendInvoiceApiSchema.params;
export const SendInvoiceHeadersSchema = SendInvoiceApiSchema.headers;
export const SendInvoiceRequestSchema = SendInvoiceApiSchema.headers.merge(SendInvoiceApiSchema.params);
export const SendInvoiceResponseSchema = SendInvoiceApiSchema.response;
